module.exports = __webpack_public_path__ + "media/images/btn_google_plus-00a04dad00f0750af04f782e49477b61.png";